import { colors } from '@parapet/common';

export const globalStyles = `
  :root {
    --primary-500: ${colors.primary};
    --primary-800: #40166b;
    
    --border-radius-lg: 10px;
    --input-bg: #222;
    --input-border-color: #333e;
    --input-border-color-hover: #eee3;
    --input-placeholder-color: #fff5;
    --input-text-color: #fff;
  }

  body {
    background-color: ${colors.gray.dark};
  }
`;
